module.exports = __webpack_public_path__ + "static/media/backhoe-loaders.951ffa5f.jpg";